import { useQuery } from 'react-query'

import { fetchReadAloudSettings } from '../../utils/readAloudAPIs'

interface UseReadAloudSettingsOptions {
  activitySessionUid?: string | null;
  skip?: boolean;
}

export const READ_ALOUD_SETTINGS_QUERY_KEY = 'read-aloud-settings'

const useReadAloudSettings = ({ activitySessionUid, skip, }: UseReadAloudSettingsOptions = {}) => {
  const { data, isFetched, } = useQuery(
    [READ_ALOUD_SETTINGS_QUERY_KEY, activitySessionUid],
    () => fetchReadAloudSettings(activitySessionUid),
    { enabled: !skip, retry: false, }
  )

  return { enabled: !skip && data?.enabled === true, loaded: !skip && isFetched, }
}

export default useReadAloudSettings
